import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Router, NavigationExtras, NavigationEnd } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { retry, catchError , map} from "rxjs/operators";
import { Subject } from "rxjs";
import { Location } from "@angular/common";
import { ToastrService } from "ngx-toastr"
import { TranslateService } from '@ngx-translate/core';

// import * as moment from "moment";
import * as moment from 'moment-timezone';
import { environment } from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  public currency:any='$';
  public playerBase:any='https://cdn.jwplayer.com/players/';

  
  baseUrl =  `${environment.apiEndPoint}`;

  public giverSelectedUser = new Subject<any>();
  private currentUser: any = {};
  private subject = new Subject<any>();
  public currYear = new Date().getFullYear();
  public Language: any;
  public monthArray: any = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  public dayArray :any=['Sun','Mon','Tue','wed','Thu','Fri','Sat'];
  public LimitArray:any=[10,20,50,100];

  constructor(
    private translate: TranslateService,
    public http: HttpClient,
    private router: Router,
    private location: Location,
    public toastr: ToastrService,
  ) {}

  // Http Options
  getHeaderLogin(type = 2) {
    var data:any = "",Id:any='';
    if (localStorage.getItem('gra_token')) {
      data = localStorage.getItem('gra_token');
    }
    if (type == 1) {
      return {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          "X-Authorization":  'Bearer '+ data,
          "version": "1.0.0",
          "lang":(localStorage.getItem('gra_language')||'en'),
          "time-zone":moment.tz.guess(),
          
        }),
      };
    } else {
      return {
        headers: new HttpHeaders({
          "X-Authorization": 'Bearer '+ data,
          "version": "1.0.0",
          "lang":(localStorage.getItem('gra_language')||'en'),
          "time-zone":moment.tz.guess(),
          
        }),
      };
    }
  }
  // Http Options
  getHeadersLogin() {
    var data:any = "",Id:any='';
    if (localStorage.getItem('gra_token')) {
      data = localStorage.getItem('gra_token');
    }
   
    return {
      headers: new HttpHeaders({
        //'Content-Type' : 'application/json, text/plain, */*',
        "X-Authorization":  'Bearer '+ data,
        "version": "1.0.0",
        "lang":(localStorage.getItem('gra_language')||'en'), 
        "time-zone":moment.tz.guess(),     
      }),
    };
  }

  setSubject(obj: any) {
    this.subject.next({ loginData: obj });
  }

  back() {
    this.location.back();
  }

  forword() {
    this.location.forward();
  }

  logOut() {
    var arr: any = [];
    const value: any = localStorage;    
    for (var i = 0; i < value.length; i++) {
      if (value.key(i).substring(0, 4) == 'gra_') {
        if (value.key(i) != 'gra_Remember') {
          arr.push(value.key(i));
        }
      }
    }
    for (var i = 0; i < arr.length; i++) {
      value.removeItem(arr[i]);
    }
    this.router.navigate(['/signin']);
  }

  /*
   * return data array
   */
  getSubject(): Observable<any> {
    return this.subject
      .asObservable()
      .pipe(retry(0), catchError(this.handleError))
  }

  // Common post api
  PostApis(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      return data;
    }))
  }

  PostApiFormData(data: any, url: any) {
    return this.http
      .post<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      return data;
    }))
  }

  // Common get api
  GetApi(url: any) {
    return this.http
      .get<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success == 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
     return data;
    }))
  }

  // Common get api
  DeleteApi(url: any) {
    return this.http
      .delete<any>(this.baseUrl + url, this.getHeaderLogin())
      .pipe(retry(0), catchError(this.handleError),
      map((data: []) => {
      const response: any = data;
      if (response.success== 0) {
        if (response.error_code == 461) {
          // this.dangerAlert(response.message);
          this.logOut();
          this.router.navigate(['/signin']);
        }
      }
      return data;
    }))
  }
  
    updateApi(data: any, url: any){
      return this.http
        .put<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
        .pipe(retry(0), catchError(this.handleError),
        map((data: []) => {
        const response: any = data;
        if (response.success== 0) {
          if (response.error_code == 461) {
            // this.dangerAlert(response.message);
            this.logOut();
            this.router.navigate(['/signin']);
          }
        }
        return data;
      })) 
    }
  
    updateApi1(data: any, url: any){
      return this.http
        .patch<any>(this.baseUrl + url, data, this.getHeaderLogin(1))
        .pipe(retry(0), catchError(this.handleError),
        map((data: []) => {
        const response: any = data;
        if (response.success== 0) {
          if (response.error_code == 461) {
            // this.dangerAlert(response.message);
            this.logOut();
            this.router.navigate(['/signin']);
          }
        }
        return data;
      })) 
    }
    
    updateFormData(data: any, url: any) {
      return this.http
        .put<any>(this.baseUrl + url, data, this.getHeaderLogin(2))
        .pipe(retry(0), catchError(this.handleError),
        map((data: []) => {
        const response: any = data;
        if (response.success == 0) {
          if (response.error_code == 461) {
            // this.dangerAlert(response.message);
            this.logOut();
            this.router.navigate(['/signin']);
          }
        }
        return data;
      }))
    }

  handleError(error: any) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  // successAlert for fire toast/...
  successAlert(msg: any) {
    this.toastr.success(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000
    });
  }

  warningAlert(msg: any) {
    this.toastr.warning(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000
    });
  }

  // successAlert for fire toast/...
  dangerAlert(msg: any) {
    this.toastr.error(msg, " ", {
      positionClass: "toast-top-right",
      timeOut: 2000
    });
  }

  // convert date in (yyyy-mm-dd)
  ToDate(date: any) {
    var day = date.toString().slice(4, 15);
    var day1 = day.split(" ");
    var newmonth =
      this.monthArray.findIndex((rank: any) => rank === day1[0]) + 1;
    if (newmonth < 10) {
      newmonth = "0" + newmonth;
    }
    // var dob = day1[2] + "-" + newmonth + "-" + day1[1];
    var dob = day1[1] + "-" + newmonth + "-" + day1[2];

    return dob;
  }

  convertDate(date: any) {
    return moment(date).format("HH:mm DD MMMM YYYY");
    var stillUtc = moment.utc(date).toDate();
    var local = moment(stillUtc).local().format(' HH:mm DD MMMM YYYY');
    return local
  }


  checkStringLength(content: string) {
    return content == undefined ? false : true;
  }

  toTimestamp(strDate:any){
    var date = new Date(strDate);
    return date
  }

  ExpiryCheck(month:any,year:any){
    var today = new Date();
      var currYear = today.getFullYear();
      var months =  today.getMonth() + 1;
      // var newmonth:any;
      // if(months < 10){
      //   newmonth = '0'+ months;
      // }
      if((month < months && year <=  currYear )||  year <  currYear) {
        // this.dangerAlert('Expiry Month & Year is not valid')
        return false;
      } else{
        return 1;
      }
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  dateConvert(Dates:any,type:any){
    var event_date_start_utc1:any='';
    event_date_start_utc1 = new Date(Dates);
    var hours:any = event_date_start_utc1.getHours();
    var minutes:any = event_date_start_utc1.getMinutes();
    debugger;
    var newformat = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var date :any = event_date_start_utc1.getDate();
    if(date < 10){
      date = '0'+ date;
    }
    var month = event_date_start_utc1.getMonth();
    var months = month +1;
    var year = event_date_start_utc1.getFullYear();
    var day = event_date_start_utc1.getDay();
    if(type == 1){
      var newdate = date+'/'+months +'/'+ year;
      return  newdate;
    } else if(type == 2){
      var newdate = this.dayArray[day]+' '+this.monthArray[month] +' '+   date +' '+ year;
      return  newdate;
    } else  if(type == 3){
      var newdate = date+' '+this.monthArray[month] +' '+ year;
      return  newdate;
    } else if(type == 4){
      var jj = Dates.split('-');
      var kk = parseInt(jj[1])-1;
      var newdate = jj[0]+' '+this.monthArray[kk] +', '+ jj[2];
      return  newdate;
    } else {
      var newdate = hours + ':' + minutes + ' ' +date+' '+this.monthArray[month] +' '+ year;
      return  newdate;
    }
  }

  dateCon(date:any){
    var mm =date.split('T');
    var ss=mm[0].split('-');
    var dd = ss[1]+'/'+ss[2]+'/'+ss[0];
    return dd ;
  }

  updateLanguage(data:any){
    localStorage.setItem('gra_language',data);
    this.translate.use(data);
  }

}

